import React from 'react';
import classNames from 'classnames';
import './pet-avatar.scss';
import { AvatarSizes } from './AvatarEnums';

export const PetAvatar = ({
  src,
  alt = '',
  size = AvatarSizes.MEDIUM,
  className = '',
}: {
  src: string;
  alt?: string;
  size: AvatarSizes;
  className?: string;
}) => (
  <img
    src={src}
    alt={alt}
    className={classNames(
      'pet-avatar',
      {
        [`pet-avatar--${size}`]: size !== AvatarSizes.MEDIUM,
      },
      className,
    )}
  />
);
